"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.warning.name.required': 'Avatar name is required to continue.',
};
